export default __webpack_public_path__ + "i18n/translations/translation-kn.cb12d90a.json";